import { create } from 'zustand';
import type Geometry from '@arcgis/core/geometry/Geometry.js';
import type Graphic from '@arcgis/core/Graphic.js';

export type SketchShape = 'polygon' | 'polyline' | 'point' | 'rectangle' | 'circle';

export type SketchEntry = {
  id: string;
  shape: SketchShape;
  geometry: Geometry;
  graphic: Graphic;
  /** Geodesic area in m² for polygon/rectangle/circle. */
  areaMeters?: number;
  /** Geodesic length in m for polyline. */
  lengthMeters?: number;
  /** [lon, lat] for point. */
  point?: [number, number];
  label: string;
};

type SketchesState = {
  entries: SketchEntry[];
  add: (entry: SketchEntry) => void;
  remove: (id: string) => void;
  clear: () => void;
};

let counter = 0;

export const useSketchesStore = create<SketchesState>((set) => ({
  entries: [],
  add: (entry) => set((s) => ({ entries: [...s.entries, entry] })),
  remove: (id) => set((s) => ({ entries: s.entries.filter((e) => e.id !== id) })),
  clear: () => set({ entries: [] }),
}));

export function nextSketchId(): string {
  counter += 1;
  return `sketch_${counter.toString(36)}`;
}
